import { Injectable } from '@angular/core';
import { map } from 'rxjs';
import { ApiService } from 'src/app/_core/_services/api.service';

@Injectable({
  providedIn: 'root'
})
export class NetworkInvoicesService {
  constructor(private api: ApiService) {}

  getInvoices() {
    return this.api.getAPI('network-portal/billing/invoices').pipe(
      map((res: any) => {
        return res.body.results;
      })
    );
  }

  getInvoicesByCustomerId(customerId: number) {
    return this.api.getAPI(`network-portal/billing/customers/${customerId}/invoices`).pipe(
      map((res: any) => {
        return res.body.results;
      })
    );
  }
}
